import { GetBodyVehicleCorrectiveImagesFormTabsParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleCorrectiveImagesFormTabs/getBodyVehicleCorrectiveImagesFormTabs.type';
import { getBodyVehicleCorrectiveImagesFormTabsTabsFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleCorrectiveImagesFormTabs/getBodyVehicleCorrectiveImagesFormTabsTabsFunction';
import { queryOptions } from '@tanstack/react-query';

const getBodyVehicleCorrectiveImagesFormTabsOptions = (
  params: GetBodyVehicleCorrectiveImagesFormTabsParamsType,
) =>
  queryOptions({
    queryKey: ['GET_BODY_VEHICLE_CORRECTIVE_IMAGE_FORM_TABS_', params],
    queryFn: () => getBodyVehicleCorrectiveImagesFormTabsTabsFunction(params),
  });
export default getBodyVehicleCorrectiveImagesFormTabsOptions;
